var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconFollow = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 15,
  height: 15,
  viewBox: "0 0 15 15",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.22946 6.71509H14V8.08868H8.22946V14H6.65331V8.08868H1V6.71509H6.65331V1H8.22946V6.71509Z",
  fill: "#CCCCCC"
})));
export default SvgIconFollow;